import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { S3ImagePipe } from './s3-image.pipe';
import { PhonePipe } from './phone.pipe';

@NgModule({
  declarations: [S3ImagePipe, PhonePipe],
  imports: [
    CommonModule
  ],
  providers:  [
    S3ImagePipe, PhonePipe
  ],
  exports: [
    S3ImagePipe,
    PhonePipe
  ]
})
export class PipesModule { }
